import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class View_record_audit extends PureComponent {
  render() {
    return (
      <div className="row" id="view_record_audit">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>View Record Audit</h2>
              <p>
                All actions against an individual record are audited. Audit log
                are read-only and continue to exist after a record has been
                deleted. Users can be given permission to view all audit logs of
                an entire object type or restricted to just the records matching
                a record level permission. The Audit log record level permission
                security is based on the record level permission assigned to the
                record at that time of request and NOT what it was historically
                when that individual audit log record was created. In the event,
                the record has been deleted; only an administrator can access
                the record’s audit history.
              </p>
              <p>
                Record audit logs support scrolling and can be filtered by
                create, read, update and delete events (see example).
              </p>
              <p>
                Create update and delete logs contain a “text_change” field
                which is a JSON object containing fields which have been added,
                changed or removed.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>View Record Audit Example</h2>
              <p>
                In this example will show the audit history for Record ID 454.
              </p>
              <p>Request:</p>
              <div className="darkCode">
                <span className="methodCodePOST">POST</span> - https://
                <span className="jsonY">example</span>.api.nexoid.com/v1/record/
                <span className="jsonY">object_type</span>/
                <span className="jsonY">454</span>/audit
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"session_id"</span>:{" "}
                  <span className="jsonY">
                    "
                    <span className="jsonO">
                      &#123;&#123;session_id&#125;&#125;
                    </span>
                    "
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"create"</span>:{" "}
                  <span className="jsonP">true</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"read"</span>:{" "}
                  <span className="jsonP">false</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"update"</span>:{" "}
                  <span className="jsonP">true</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"delete"</span>:{" "}
                  <span className="jsonP">true</span>
                </div>
                <div>&#125;</div>
              </div>
              <p>Response:</p>
              <div className="darkCode">
                <div>
                  Code: <span className="statusCode">200</span>
                </div>
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"took"</span>:{" "}
                  <span className="jsonP">3</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"timeout"</span>:{" "}
                  <span className="jsonP">false</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"total"</span>:{" "}
                  <span className="jsonP">1</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"records"</span>: [ ... ]{" "}
                </div>
                <div>&#125;</div>
              </div>
            </section>

            <section>
              <h3>Example 2: Scrolling</h3>
              <p>
                In the first scroll query we added the parameter scroll = true.
                The query performs as usual in addition to returning a
                scroll_id.
              </p>
              <p>Request:</p>
              <div className="darkCode">
                <span className="methodCodePOST">POST</span> - https://
                <span className="jsonY">example</span>.api.nexoid.com/v1/record/
                <span className="jsonY">object_type</span>/
                <span className="jsonY">454</span>/audit
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"session_id"</span>:{" "}
                  <span className="jsonY">
                    "
                    <span className="jsonO">
                      &#123;&#123;session_id&#125;&#125;
                    </span>
                    "
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"scroll"</span>:{" "}
                  <span className="jsonP">true</span>
                </div>
                <div>&#125;</div>
              </div>
              <p>The response includes the Scroll ID.</p>
              <p>Response:</p>
              <div className="darkCode">
                <div>
                  Code: <span className="statusCode">200</span>
                </div>
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"took"</span>:{" "}
                  <span className="jsonP">6</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"timeout"</span>:{" "}
                  <span className="jsonP">false</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"total"</span>:{" "}
                  <span className="jsonP">10</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"records"</span>: [ ... ],
                </div>
                <div className="i1">
                  <span className="jsonG">"scroll_id"</span>:{" "}
                  <span className="jsonY">
                    "DnF1ZXJ5VGhlbkZldGNoBQAAAu2VFnltem55Z3AtN"
                  </span>
                </div>
                <div>&#125;</div>
              </div>

              <p>
                To retrieve the next batch add the scroll_id to the request. You
                can keep resending this request until you have scrolled through
                the entire data set.
              </p>
              <p>Request:</p>
              <div className="darkCode">
                <span className="methodCodePOST">POST</span> - https://
                <span className="jsonY">example</span>.api.nexoid.com/v1/record/
                <span className="jsonY">object_type</span>/
                <span className="jsonY">454</span>/audit
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"session_id"</span>:{" "}
                  <span className="jsonY">
                    "
                    <span className="jsonO">
                      &#123;&#123;session_id&#125;&#125;
                    </span>
                    "
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"scroll_id"</span>:{" "}
                  <span className="jsonY">
                    "DnF1ZXJ5VGhlbkZldGNoBQAAAu2VFnltem55Z3AtN"
                  </span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default View_record_audit;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/View_record_audit.js